<template>
  <a-card title="Dokumen Karyawan">
    <a-button v-if="getAuth.divisi[0] == 'HRD'" slot="extra" @click="handleModalEdit()">Ubah Data</a-button>
    <a-row>
      <a-col :xs="{ span: 24}" :lg="{ span: 12 }">
        <div class="m-bottom">
          <h4 class="m-remove">No Ijazah</h4>
          <span class="m-text-medium" v-if="data.dokumen">{{data.dokumen.no_ijazah}}</span>
        </div>
        <div class="m-bottom">
          <h4 class="m-remove">Asal Universitas</h4>
          <span class="m-text-medium" v-if="data.dokumen" >{{data.dokumen.asal_univ}}</span>
        </div>
        <div class="m-bottom">
          <h4 class="m-remove">Tahun Lulus</h4>
          <span class="m-text-medium" v-if="data.dokumen">{{data.dokumen.tahun_lulus}}</span>
        </div>
        <div class="m-bottom">
          <h4 class="m-remove">Pendidikan Terakhir</h4>
          <span class="m-text-medium" v-if="data.dokumen">{{data.dokumen.pendidikan_terakhir}}</span>
        </div>
        <div class="m-bottom">
          <h4 class="m-remove">No. NPWP</h4>
          <span
            class="m-text-medium"
            v-if="data.dokumen" >{{data.dokumen.no_npwp ? data.dokumen.no_npwp : 'Belum Memiliki NPWP'}}</span>
        </div>
      </a-col>
      <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
        <div class="m-bottom">
          <h4 class="m-remove">No. Ketenagakerjaan</h4>
          <span class="m-text-medium" v-if="data.dokumen">{{data.dokumen.no_tenagakerja}}</span>
        </div>
        <div class="m-bottom">
          <h4 class="m-remove">No. BPJS</h4>
          <span class="m-text-medium" v-if="data.dokumen">{{data.dokumen.no_bpjs}}</span>
        </div>
        <div class="m-bottom">
          <h4 class="m-remove">Bank</h4>
          <span class="m-text-medium" v-if="data.dokumen">{{data.dokumen.bank}}</span>
        </div>
        <div class="m-bottom">
          <h4 class="m-remove">No. Rekening</h4>
          <span class="m-text-medium" v-if="data.dokumen">{{data.dokumen.no_rekening}}</span>
        </div>
        <div class="m-bottom">
          <h4 class="m-remove">Admin Bank</h4>
          <span class="m-text-medium" v-if="data.dokumen">{{formatRupiah(data.dokumen.admin_bank)}}</span>
        </div>
      </a-col>
    </a-row>

    <a-modal :width="800" title="Edit Data Kepegawaian" :visible="visible" @cancel="handleCancel">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="btnLoading" @click="handleOk">Submit</a-button>
      </template>
      <a-form class="m-form" :form="form">
        <a-row :gutter="8">
          <a-col span="12">
            <a-form-item label="ijazah">
              <a-input
                autocomplete="off"
                v-decorator="['no_ijazah', {rules: [{required: true}], initialValue: initial.no_ijazah}]"
              />
            </a-form-item>
            <a-form-item label="Asal Universitas">
              <a-input
                autocomplete="off"
                v-decorator="['asal_univ', {rules: [{required: true}], initialValue: initial.asal_univ}]"
              />
            </a-form-item>
            <a-form-item label="Tahun Lulus">
              <a-input
                autocomplete="off"
                maxlength="4"
                v-decorator="['thn_lulus', {rules: [{required: true}], initialValue: initial.tahun_lulus}]"
              />
            </a-form-item>
            <a-form-item label="Pendidikan Terakhir">
              <a-select
                v-decorator="['pendidikan_akhir', {rules: [{required: true}], initialValue: initial.pendidikan_terakhir}]"
              >
                <a-select-option key="1" value="SMP">SMP</a-select-option>
                <a-select-option key="2" value="SMA">SMA</a-select-option>
                <a-select-option key="3" value="D1">D1</a-select-option>
                <a-select-option key="4" value="D2">D2</a-select-option>
                <a-select-option key="5" value="D3">D3</a-select-option>
                <a-select-option key="6" value="D4">D4</a-select-option>
                <a-select-option key="7" value="S1">S1</a-select-option>
                <a-select-option key="8" value="S2">S2</a-select-option>
                <a-select-option key="9" value="S3">S3</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="No. NPWP">
              <a-input autocomplete="off" v-decorator="['npwp', {initialValue: initial.no_npwp }]" />
            </a-form-item>
          </a-col>
          <a-col span="12">
            <a-form-item label="No. Ketenagakerjaan">
              <a-input
                autocomplete="off"
                v-decorator="['no_kpj', {initialValue: initial.no_tenagakerja}]"
              />
            </a-form-item>
            <a-form-item label="BPJS">
              <a-input
                autocomplete="off"
                v-decorator="['no_bpjs', {initialValue: initial.no_bpjs}]"
              />
            </a-form-item>
            <a-form-item label="No Rekening">
              <a-input
                autocomplete="off"
                v-decorator="['no_rek', {initialValue: initial.no_rekening}]"
              />
            </a-form-item>
            <a-form-item label="Bank">
              <a-select allowClear v-decorator="['bank', {initialValue: initial.bank}]">
                <a-select-option
                  v-for="bank in getBank"
                  :key="bank.code"
                  :value="bank.name"
                >{{bank.name}}</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item label="Admin Bank">
              <a-input-number id="inputNumber" :min="1"
              :formatter="rupiahFormatter"
              :parser="rupiahParser"
              class="w-full" 
                v-decorator="[
                  'admin_bank',
                  { 
                    rules: [{ required: true,message: 'Admin bank is required!' }],
                    initialValue: initial.admin_bank 
                  }
                ]"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";

export default {
  mixins: [CurrencyFormat],
  props: ["data"],
  data() {
    return {
      visible: false,
      btnLoading: false
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  created() {
    this.$store.dispatch("Fetch_Bank");
  },
  computed: {
    ...mapGetters(["getAuth", "getDefaultDateFormat", "getBank"]),
    initial() {

        let initialData = {};
        if (! _.isEmpty(this.data.dokumen)) {
            initialData = {
                  asal_univ: this.data.dokumen.asal_univ,
                  bank: this.data.dokumen.bank,
                  no_bpjs: this.data.dokumen.no_bpjs,
                  no_ijazah: this.data.dokumen.no_ijazah,
                  no_npwp: this.data.dokumen.no_npwp,
                  no_rekening: this.data.dokumen.no_rekening,
                  no_tenagakerja: this.data.dokumen.no_tenagakerja,
                  pendidikan_terakhir: this.data.dokumen.pendidikan_terakhir,
                  tahun_lulus: this.data.dokumen.tahun_lulus,
                  admin_bank: this.data.dokumen.admin_bank
                }
        }
        return initialData ;

    }
  },
  methods: {
    rupiahFormatter(value) {
      if (value === undefined || value === null || value === '') return ''
      // value bisa number atau string "1234567"
      const num = String(value).replace(/\D/g, '')
      if (!num) return ''
      // tambahin thousand separator '.'
      return 'Rp ' + num.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },

    rupiahParser(displayValue) {
      if (!displayValue && displayValue !== 0) return undefined
      // buang semua non-digit
      const digits = String(displayValue).replace(/\D/g, '')
      // return number (InputNumber menyimpan ini sebagai nilai)
      return digits === '' ? undefined : Number(digits)
    },

    moment,
    handleModalEdit() {
      this.visible = true;
    },
    handleCancel() {
      this.form.resetFields();
      this.visible = false;
    },
    handleOk() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        this.confirmMessage("confirm-edit");
      });
    },
    submit() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        this.btnLoading = true;
        let postData = new FormData();
        console.log(values);
        
        postData.append("tlc", this.data.profile.tlc);
        postData.append("no_ijazah", values.no_ijazah);
        postData.append("asal_univ", values.asal_univ);
        postData.append("thn_lulus", values.thn_lulus);
        postData.append("pendidikan_akhir", values.pendidikan_akhir);
        postData.append("npwp", values.npwp);
        postData.append("no_kpj", values.no_kpj);
        postData.append("no_bpjs", values.no_bpjs);
        postData.append("bank", values.bank);
        postData.append("no_rek", values.no_rek);
        postData.append("admin_bank", values.admin_bank);

        axios({
          method: "post",
          url: this.$serviceUrl + "master_karyawan/edit_document",
          processData: false,
          data: postData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey
          }
        }).then(response => {
          this.displayMessage("success-edit");
          this.btnLoading = false;
          this.$router.go();
        }).catch(err => {
          this.btnLoading = false;
        });

      });
    }
  },
  mounted() {
    Event.$on("confirmMessageEdit", this.submit);
  },
  beforeDestroy() {
    Event.$off("confirmMessageEdit", this.submit);
  }
};
</script>

<style>
</style>
